import React, { useState, useEffect } from 'react'
import { Col, Message, Panel, Row } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import InputForm from '../../../components/forms/input/InputForm'
import CKEditorFrom from '../../../components/forms/input/CKEditorFrom'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import ActivitieBudgetWidget from './ActivitieBudgetWidget'
import SettingEditFormListWidget from '../dynamicForm/SettingEditFormListWidget'
import { CANCEL, DEFAULT_ERR_MSG, DELETE, SAVE, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import {
  createDynamicListReq,
  setValueDynamicToReq,
  setValueDynamicToReqByName,
} from '../../../utils/dynamicListReq'
import { doneLoading, startLoading } from '../../../utils/loading'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import EditFormListWidget from '../dynamicForm/EditFormListWidget'
import ActivitieTimeWidget from './ActivitieTimeWidget'
import { saveFormActivity } from '../../../redux/actions/subProjectProposal'
import { setAlertMessage } from '../../../utils/messageUtil'

export default function ActivitieFormWidget({
  schema,
  activity,
  activityIndex,
  onDelete = () => {},
  updateActivities = () => {},
  setHaveChange = () => {},
  updateBudgetTotal = () => {},
  isSubmitAll,
  ...props
}) {
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(schema)
  const [activitySchema, setActivitySchema] = useState(activity)
  const [originalActivity, setOriginalActivity] = useState(activity)
  const [notiMsg, setNotiMsg] = useState()
  const [isRefash, setIsRefash] = useState(false)

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  // useEffect(() => {
  //   setActivities(props.schema.activities || [])
  // }, [props.schema])

  useEffect(() => {
    if (isSubmitAll) {
      handleSubmit(onSubmit)
    }
  }, [isSubmitAll])

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveFormActivity(subProjectId, request)
      if (response) {
        setActivitySchema(response)
        setOriginalActivity(response)

        setAlertMessage('success', SAVE_SUCCESS_MSG, setNotiMsg)

        onRefash()

        let total = response.activityBudgetDatas?.reduce(
          (sum, item) => sum + item.quantity * item.price,
          0
        )

        updateBudgetTotal(response.id, total)
        setHaveChange(true)

        // scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG, setNotiMsg)
      }
    } catch (e) {
      console.log('error', e)

      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG, setNotiMsg)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    //console.log('data', data)

    let outcomes = setValueDynamicToReqByName(activitySchema?.outcomes, data)

    let newOutcomes = createDynamicListReq(data.newObjects, data.newObjectsValuesName)

    let activityTimes = []

    activitySchema.activityTimeForm?.forEach((e) => {
      activityTimes.push({
        refId: e.name,
        value: data[e.name] || null,
      })
    })

    let budgetDatas = []

    data.budgetDataName?.forEach((value, key) => {
      budgetDatas.push(value)
    })

    let request = {
      id: activitySchema.id,
      refId: activitySchema.refId,
      activityName: data[formSchema.activityForm.activityName.name] || activitySchema.activityName,
      activityDetail:
        data[formSchema.activityForm.activityDetail.name] || activitySchema.activityDetail,
      outcomes: outcomes,
      newOutcomes: newOutcomes,
      activityTimes: activityTimes,
      newActivityTimes: data.newActivitieTimeName || [],
      activityBudgets: budgetDatas,
    }

    //console.log('request : ', JSON.stringify(request))

    handleSave(request)
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  return (
    <Panel
      //header={`กิจกรรมที่ ${activityIndex + 1}`}
      header={activitySchema.activityName || 'กิจกรรม'}
      collapsible
      defaultExpanded
      // shaded
      bordered
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {!isRefash && (
        <>
          {!activitySchema.refId ? (
            <>
              <InputForm
                schema={formSchema.activityForm.activityName}
                //name={formSchema.activityForm.activityName + '_' + index}
                value={activitySchema.activityName}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />

              <CKEditorFrom
                schema={formSchema.activityForm.activityDetail}
                //name={formSchema.activityForm.activityDetail + '_' + index}
                value={activitySchema.activityDetail}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </>
          ) : (
            <>
              <Row style={{ marginBottom: 20 }}>
                <Col style={{ marginBottom: 10 }}>
                  <strong>{formSchema.activityForm.activityName.label}</strong>{' '}
                </Col>
                <Col style={{ marginLeft: 20 }}>{activitySchema.activityName}</Col>
              </Row>
              <Row style={{ marginBottom: 20 }}>
                <Col style={{ marginBottom: 10 }}>
                  <strong>{formSchema.activityForm.activityDetail.label}</strong>
                </Col>
                <Col style={{ marginLeft: 20 }}>
                  {/* <div
                    dangerouslySetInnerHTML={{
                      __html: activitySchema.activityDetail,
                    }}
                  /> */}
                  <CKEditorFrom
                    schema={formSchema.activityForm.activityDetail}
                    //name={formSchema.activityForm.activityDetail + '_' + index}
                    value={activitySchema.activityDetail}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
              </Row>
            </>
          )}

          <Panel
            // style={{ marginTop: -22 }}
            header={'ผลลัพธ์/ผลผลิต'}
            collapsible
            defaultExpanded
            bordered
          >
            <div style={{ marginTop: -10, marginBottom: 10 }}>
              <EditFormListWidget
                // schema={e.outcome}
                schema={formSchema.outcomeForm}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                getValues={getValues}
                clearErrors={clearErrors}
                setLoading={setIsLoading}
                values={activitySchema.outcomes || []}
              />
              <div style={{ marginTop: -40, marginBottom: -30 }}>
                <SettingEditFormListWidget
                  // schema={e.outcome}
                  inputMode
                  schema={formSchema.outcomeForm}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  getValues={getValues}
                  clearErrors={clearErrors}
                  setLoading={setIsLoading}
                  datas={activitySchema.newOutcomes || []}
                  buttonText="ผลลัพธ์/ผลผลิต"
                />
              </div>
            </div>
          </Panel>

          <ActivitieTimeWidget
            // style={{ marginTop: -22 }}
            bordered
            schema={formSchema.activityTimeForm}
            header={'ช่วงเวลาที่จัดกิจกรรม'}
            items={activitySchema.activityTimeForm}
            newItems={activitySchema.activityTime}
            activityId={activitySchema.id}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />

          <ActivitieBudgetWidget
            // style={{ marginTop: -22 }}
            bordered
            header={'งบประมาณ'}
            dataList={activitySchema.activityBudgetDatas || []}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            budgetNote={activitySchema.activityBudgetNote}
          />

          {!mode && (
            <div className="right">
              <hr />
              {notiMsg && (
                <Message
                  closable
                  showIcon
                  type={notiMsg.type}
                  description={notiMsg.msg}
                  onClose={() => setNotiMsg('')}
                  style={{ marginBottom: 10 }}
                />
              )}

              <SaveButton children={`${SAVE}กิจกรรม`} onClick={handleSubmit(onSubmit)} />
              {activitySchema.enableDelete && (
                <CancelButton
                  icon="trash-o"
                  children={`${DELETE}กิจกรรม`}
                  onClick={() => {
                    onDelete(activitySchema.id, activityIndex)
                  }}
                />
              )}

              <CancelButton
                children={CANCEL}
                onClick={() => {
                  setActivitySchema(originalActivity)
                  onRefash()
                }}
              />
            </div>
          )}
        </>
      )}

      {isLoading && <OverlayLoader />}
    </Panel>
  )
}
